import type { StatusTone } from "../../utils/sessionStatus";

/**
 * Legacy status key from the old Session type.
 * Kept for backward compat with Dashboard's SessionRow.
 */
type LegacyStatus = "confirmed" | "awaiting" | "needs-action" | "scheduled" | "new";

interface StatusBadgeProps {
  /** Label text displayed next to the dot */
  label: string;
  /** Tone drives the dot/text color. Takes precedence over `status`. */
  tone?: StatusTone;
  /** Legacy: maps old status keys to tones. Use `tone` for new code. */
  status?: LegacyStatus;
}

const TONE_MAP: Record<StatusTone, { textColor: string; dotColor: string }> = {
  sage: { textColor: "text-sage", dotColor: "bg-sage" },
  spark: { textColor: "text-spark", dotColor: "bg-spark" },
  rust: { textColor: "text-rust", dotColor: "bg-rust" },
  "ink-4": { textColor: "text-ink-4", dotColor: "bg-ink-5" },
  "ink-5": { textColor: "text-ink-4", dotColor: "bg-ink-5" },
};

const LEGACY_TONE_MAP: Record<LegacyStatus, StatusTone> = {
  confirmed: "sage",
  awaiting: "spark",
  "needs-action": "rust",
  scheduled: "ink-4",
  new: "ink-5",
};

export function StatusBadge({ label, tone, status }: StatusBadgeProps) {
  const resolvedTone = tone ?? (status ? LEGACY_TONE_MAP[status] : "ink-5");
  const config = TONE_MAP[resolvedTone] ?? TONE_MAP["ink-5"];

  return (
    <div
      className={`inline-flex items-center gap-1.5 text-[11.5px] font-medium ${config.textColor}`}
    >
      <div className={`dot ${config.dotColor}`} />
      {label}
    </div>
  );
}
